import { render, staticRenderFns } from "./DesginationList.vue?vue&type=template&id=53801a98"
import script from "./DesginationList.vue?vue&type=script&lang=js"
export * from "./DesginationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports